import React from 'react';
import { connect } from 'react-redux';

import Root from './../viewport/Root';

import * as fromActions from './../actions';

import tabs from './../actions/tabs';

const mapStateToProps = (state, ownProps) => ({
    router: state.router,
    session: JSON.parse(window.sessionStorage.getItem('session')),
    collapse: state.collapse,
    tabs: state.tabs
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    updateAccount: (account) => {
        dispatch(fromActions.login(account));
    },

    sitemap: (route) => {
        dispatch(fromActions.sitemap(route));
    },

    toggleCollapsed:(collapsed) => {
        dispatch(fromActions.toggle(collapsed));
    },

    insertOrUpdateTab: (tab) => {
        let url = tab.url;
        if(!url.includes('ebibase/showcoolrpt.do')) {
            url = url.toLowerCase();
        }
        dispatch(tabs.insert(Object.assign({}, tab, {url})));
    },

    removeTab: (tab) => {
        dispatch(tabs.remove(tab));  
    }
});


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Root);